var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBackToTopStatus),expression:"showBackToTopStatus"}],ref:"vGotop",staticClass:"o-gotoTop",style:(_vm.goTopStyle),on:{"click":_vm.goToTop}},[_c('img',{style:(_vm.getTopImageStyle),attrs:{"src":`${_vm.$publicPath}${_vm.imgUrl}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }